import React from "react";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import {
  buttonSecondarynstyle,
  buttonStyleSm,
  buttonloginstyle2Sm,
} from "../../help/Utils";
import { IoMdAdd } from "react-icons/io";
import StepperForm from "./StepperForm";

const ApplicationForm: React.FC = () => {
  return (
    <>
      <StepperForm/>
    </>
  );
};

export default ApplicationForm;
